/**
 * AUTO-GENERATED - DO NOT EDIT
 *
 * Generated by: apps/docs/build/generate-api-whitelist.ts
 * Source: packages/0/src/components/ and packages/0/src/composables/
 *
 * This file is regenerated on every build. To add new entries,
 * create the component/composable in the source directories.
 */

/**
 * v0 component namespaces that get API hover treatment.
 * Discovered from: packages/0/src/components/
 */
export const V0_COMPONENTS = new Set([
  'Alert',
  'AlertDialog',
  'AspectRatio',
  'Atom',
  'Avatar',
  'Breadcrumbs',
  'Button',
  'Carousel',
  'Checkbox',
  'Collapsible',
  'Combobox',
  'DataGrid',
  'DataTable',
  'Dialog',
  'ExpansionPanel',
  'Form',
  'Group',
  'Image',
  'Input',
  'Kanban',
  'Locale',
  'Menu',
  'NumberField',
  'Otp',
  'Overflow',
  'Pagination',
  'Popover',
  'Portal',
  'Presence',
  'Progress',
  'Radio',
  'Rating',
  'Scrim',
  'Select',
  'Selection',
  'Single',
  'Slider',
  'Snackbar',
  'Splitter',
  'Step',
  'Switch',
  'Tabs',
  'Theme',
  'Toggle',
  'Tooltip',
  'Tour',
  'Treeview',
  'Virtualizer',
  'fixtures',
])

/**
 * v0 composables with API entries.
 * Discovered from: packages/0/src/composables/
 *
 * Includes directory names and common export variants
 * (useX, createXPlugin, createXContext).
 */
export const V0_COMPOSABLES = new Set([
  'createBreadcrumbs',
  'createBreadcrumbsContext',
  'createBreakpoints',
  'createBreakpointsContext',
  'createBreakpointsPlugin',
  'createCombobox',
  'createComboboxContext',
  'createContext',
  'createDataGrid',
  'createDataGridContext',
  'createDataTable',
  'createDataTableContext',
  'createDate',
  'createDateContext',
  'createDatePlugin',
  'createFallbackHydration',
  'createFeatures',
  'createFeaturesContext',
  'createFeaturesPlugin',
  'createFilter',
  'createFilterContext',
  'createForm',
  'createFormContext',
  'createGroup',
  'createGroupContext',
  'createHydration',
  'createHydrationContext',
  'createHydrationPlugin',
  'createInput',
  'createKanban',
  'createLocale',
  'createLocaleContext',
  'createLocaleFallback',
  'createLocalePlugin',
  'createLogger',
  'createLoggerContext',
  'createLoggerPlugin',
  'createModel',
  'createMyFeature',
  'createNested',
  'createNestedContext',
  'createNotifications',
  'createNotificationsContext',
  'createNotificationsPlugin',
  'createNumberField',
  'createNumeric',
  'createOtp',
  'createOverflow',
  'createOverflowContext',
  'createPagination',
  'createPaginationContext',
  'createPermissions',
  'createPermissionsContext',
  'createPermissionsPlugin',
  'createPlugin',
  'createPluginContext',
  'createPopoverContext',
  'createPopoverFallback',
  'createPopoverPlugin',
  'createProgress',
  'createProgressContext',
  'createQueue',
  'createQueueContext',
  'createRating',
  'createRatingContext',
  'createReducedMotion',
  'createReducedMotionContext',
  'createReducedMotionPlugin',
  'createRegistry',
  'createRegistryContext',
  'createRtl',
  'createRtlContext',
  'createRtlFallback',
  'createRtlPlugin',
  'createRules',
  'createRulesContext',
  'createRulesFallback',
  'createRulesPlugin',
  'createSelection',
  'createSelectionContext',
  'createSingle',
  'createSingleContext',
  'createSlider',
  'createSortable',
  'createStack',
  'createStackContext',
  'createStackPlugin',
  'createStep',
  'createStepContext',
  'createStorage',
  'createStorageContext',
  'createStoragePlugin',
  'createTheme',
  'createThemeContext',
  'createThemePlugin',
  'createTimeline',
  'createTimelineContext',
  'createTokens',
  'createTokensContext',
  'createTooltipContext',
  'createTooltipFallback',
  'createTooltipPlugin',
  'createTour',
  'createTourContext',
  'createTourPlugin',
  'createTrinity',
  'createValidation',
  'createVirtual',
  'createVirtualContext',
  'provideAppLogger',
  'provideAppPopover',
  'provideCheckboxes',
  'provideContext',
  'provideHydrationContext',
  'provideItems',
  'provideMyForm',
  'provideMyGroup',
  'providePermissions',
  'provideQueue',
  'provideSearchFilter',
  'provideSingle',
  'provideStep',
  'provideTabs',
  'provideTimeline',
  'provideTokens',
  'provideTree',
  'toArray',
  'toElement',
  'toHighlight',
  'toPlacement',
  'toReactive',
  'useAppLogger',
  'useAppPopover',
  'useBreadcrumbs',
  'useBreakpoints',
  'useCheckboxes',
  'useClickOutside',
  'useCombobox',
  'useContext',
  'useDataGrid',
  'useDataTable',
  'useDate',
  'useDelay',
  'useDocumentEventListener',
  'useDragDrop',
  'useElementIntersection',
  'useElementSize',
  'useEventListener',
  'useFeatures',
  'useFilter',
  'useFocusTrap',
  'useForm',
  'useGroup',
  'useHotkey',
  'useHydration',
  'useHydrationContext',
  'useImage',
  'useIntersectionObserver',
  'useItems',
  'useLazy',
  'useLocale',
  'useLogger',
  'useMediaQuery',
  'useMutationObserver',
  'useMyForm',
  'useMyGroup',
  'useNested',
  'useNotifications',
  'useOverflow',
  'usePagination',
  'usePermissions',
  'usePopover',
  'usePrefersContrast',
  'usePrefersDark',
  'usePrefersReducedMotion',
  'usePresence',
  'useProgress',
  'useProxyModel',
  'useProxyRegistry',
  'useQueue',
  'useRaf',
  'useRating',
  'useReducedMotion',
  'useRegistry',
  'useResizeObserver',
  'useRovingFocus',
  'useRtl',
  'useRules',
  'useSearchFilter',
  'useSelection',
  'useSingle',
  'useStack',
  'useStep',
  'useStorage',
  'useTabs',
  'useTheme',
  'useTimeline',
  'useTimer',
  'useToggleScope',
  'useTokens',
  'useTooltip',
  'useTour',
  'useTree',
  'useTypeahead',
  'useVirtual',
  'useVirtualFocus',
  'useWindowEventListener',
])

/**
 * Maps composable function names to their directory name (API cache key).
 * Used by the shiki-api-transformer to resolve the correct API page.
 */
export const V0_COMPOSABLE_TO_DIR: Record<string, string> = {
  'createBreadcrumbs': 'createBreadcrumbs',
  'createBreadcrumbsContext': 'createBreadcrumbs',
  'createBreakpoints': 'useBreakpoints',
  'createBreakpointsContext': 'useBreakpoints',
  'createBreakpointsPlugin': 'useBreakpoints',
  'createCombobox': 'createCombobox',
  'createComboboxContext': 'createCombobox',
  'createContext': 'createContext',
  'createDataGrid': 'createDataGrid',
  'createDataGridContext': 'createDataGrid',
  'createDataTable': 'createDataTable',
  'createDataTableContext': 'createDataTable',
  'createDate': 'useDate',
  'createDateContext': 'useDate',
  'createDatePlugin': 'useDate',
  'createFallbackHydration': 'useHydration',
  'createFeatures': 'useFeatures',
  'createFeaturesContext': 'useFeatures',
  'createFeaturesPlugin': 'useFeatures',
  'createFilter': 'createFilter',
  'createFilterContext': 'createFilter',
  'createForm': 'createForm',
  'createFormContext': 'createForm',
  'createGroup': 'createGroup',
  'createGroupContext': 'createGroup',
  'createHydration': 'useHydration',
  'createHydrationContext': 'useHydration',
  'createHydrationPlugin': 'useHydration',
  'createInput': 'createInput',
  'createKanban': 'createKanban',
  'createLocale': 'useLocale',
  'createLocaleContext': 'useLocale',
  'createLocaleFallback': 'useLocale',
  'createLocalePlugin': 'useLocale',
  'createLogger': 'useLogger',
  'createLoggerContext': 'useLogger',
  'createLoggerPlugin': 'useLogger',
  'createModel': 'createModel',
  'createMyFeature': 'createTrinity',
  'createNested': 'createNested',
  'createNestedContext': 'createNested',
  'createNotifications': 'useNotifications',
  'createNotificationsContext': 'useNotifications',
  'createNotificationsPlugin': 'useNotifications',
  'createNumberField': 'createNumberField',
  'createNumeric': 'createNumeric',
  'createOtp': 'createOtp',
  'createOverflow': 'createOverflow',
  'createOverflowContext': 'createOverflow',
  'createPagination': 'createPagination',
  'createPaginationContext': 'createPagination',
  'createPermissions': 'usePermissions',
  'createPermissionsContext': 'usePermissions',
  'createPermissionsPlugin': 'usePermissions',
  'createPlugin': 'createPlugin',
  'createPluginContext': 'createPlugin',
  'createPopoverContext': 'usePopover',
  'createPopoverFallback': 'usePopover',
  'createPopoverPlugin': 'usePopover',
  'createProgress': 'createProgress',
  'createProgressContext': 'createProgress',
  'createQueue': 'createQueue',
  'createQueueContext': 'createQueue',
  'createRating': 'createRating',
  'createRatingContext': 'createRating',
  'createReducedMotion': 'useReducedMotion',
  'createReducedMotionContext': 'useReducedMotion',
  'createReducedMotionPlugin': 'useReducedMotion',
  'createRegistry': 'createRegistry',
  'createRegistryContext': 'createRegistry',
  'createRtl': 'useRtl',
  'createRtlContext': 'useRtl',
  'createRtlFallback': 'useRtl',
  'createRtlPlugin': 'useRtl',
  'createRules': 'useRules',
  'createRulesContext': 'useRules',
  'createRulesFallback': 'useRules',
  'createRulesPlugin': 'useRules',
  'createSelection': 'createSelection',
  'createSelectionContext': 'createSelection',
  'createSingle': 'createSingle',
  'createSingleContext': 'createSingle',
  'createSlider': 'createSlider',
  'createSortable': 'createSortable',
  'createStack': 'useStack',
  'createStackContext': 'useStack',
  'createStackPlugin': 'useStack',
  'createStep': 'createStep',
  'createStepContext': 'createStep',
  'createStorage': 'useStorage',
  'createStorageContext': 'useStorage',
  'createStoragePlugin': 'useStorage',
  'createTheme': 'useTheme',
  'createThemeContext': 'useTheme',
  'createThemePlugin': 'useTheme',
  'createTimeline': 'createTimeline',
  'createTimelineContext': 'createTimeline',
  'createTokens': 'createTokens',
  'createTokensContext': 'createTokens',
  'createTooltipContext': 'useTooltip',
  'createTooltipFallback': 'useTooltip',
  'createTooltipPlugin': 'useTooltip',
  'createTour': 'useTour',
  'createTourContext': 'useTour',
  'createTourPlugin': 'useTour',
  'createTrinity': 'createTrinity',
  'createValidation': 'createValidation',
  'createVirtual': 'createVirtual',
  'createVirtualContext': 'createVirtual',
  'provideAppLogger': 'useLogger',
  'provideAppPopover': 'usePopover',
  'provideCheckboxes': 'createSelection',
  'provideContext': 'createContext',
  'provideHydrationContext': 'useHydration',
  'provideItems': 'createRegistry',
  'provideMyForm': 'createForm',
  'provideMyGroup': 'createGroup',
  'providePermissions': 'usePermissions',
  'provideQueue': 'createQueue',
  'provideSearchFilter': 'createFilter',
  'provideSingle': 'createSingle',
  'provideStep': 'createStep',
  'provideTabs': 'createSelection',
  'provideTimeline': 'createTimeline',
  'provideTokens': 'createTokens',
  'provideTree': 'createNested',
  'toArray': 'toArray',
  'toElement': 'toElement',
  'toHighlight': 'toHighlight',
  'toPlacement': 'usePopover',
  'toReactive': 'toReactive',
  'useAppLogger': 'useLogger',
  'useAppPopover': 'usePopover',
  'useBreadcrumbs': 'createBreadcrumbs',
  'useBreakpoints': 'useBreakpoints',
  'useCheckboxes': 'createSelection',
  'useClickOutside': 'useClickOutside',
  'useCombobox': 'createCombobox',
  'useContext': 'createContext',
  'useDataGrid': 'createDataGrid',
  'useDataTable': 'createDataTable',
  'useDate': 'useDate',
  'useDelay': 'useDelay',
  'useDocumentEventListener': 'useEventListener',
  'useDragDrop': 'useDragDrop',
  'useElementIntersection': 'useIntersectionObserver',
  'useElementSize': 'useResizeObserver',
  'useEventListener': 'useEventListener',
  'useFeatures': 'useFeatures',
  'useFilter': 'createFilter',
  'useFocusTrap': 'useFocusTrap',
  'useForm': 'createForm',
  'useGroup': 'createGroup',
  'useHotkey': 'useHotkey',
  'useHydration': 'useHydration',
  'useHydrationContext': 'useHydration',
  'useImage': 'useImage',
  'useIntersectionObserver': 'useIntersectionObserver',
  'useItems': 'createRegistry',
  'useLazy': 'useLazy',
  'useLocale': 'useLocale',
  'useLogger': 'useLogger',
  'useMediaQuery': 'useMediaQuery',
  'useMutationObserver': 'useMutationObserver',
  'useMyForm': 'createForm',
  'useMyGroup': 'createGroup',
  'useNested': 'createNested',
  'useNotifications': 'useNotifications',
  'useOverflow': 'createOverflow',
  'usePagination': 'createPagination',
  'usePermissions': 'usePermissions',
  'usePopover': 'usePopover',
  'usePrefersContrast': 'useMediaQuery',
  'usePrefersDark': 'useMediaQuery',
  'usePrefersReducedMotion': 'useMediaQuery',
  'usePresence': 'usePresence',
  'useProgress': 'createProgress',
  'useProxyModel': 'useProxyModel',
  'useProxyRegistry': 'useProxyRegistry',
  'useQueue': 'createQueue',
  'useRaf': 'useRaf',
  'useRating': 'createRating',
  'useReducedMotion': 'useReducedMotion',
  'useRegistry': 'createRegistry',
  'useResizeObserver': 'useResizeObserver',
  'useRovingFocus': 'useRovingFocus',
  'useRtl': 'useRtl',
  'useRules': 'useRules',
  'useSearchFilter': 'createFilter',
  'useSelection': 'createSelection',
  'useSingle': 'createSingle',
  'useStack': 'useStack',
  'useStep': 'createStep',
  'useStorage': 'useStorage',
  'useTabs': 'createSelection',
  'useTheme': 'useTheme',
  'useTimeline': 'createTimeline',
  'useTimer': 'useTimer',
  'useToggleScope': 'useToggleScope',
  'useTokens': 'createTokens',
  'useTooltip': 'useTooltip',
  'useTour': 'useTour',
  'useTree': 'createNested',
  'useTypeahead': 'useTypeahead',
  'useVirtual': 'createVirtual',
  'useVirtualFocus': 'useVirtualFocus',
  'useWindowEventListener': 'useEventListener',
}
